import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'
import { useMemo } from 'react'

import { DEFAULT_DEADLINE_FROM_NOW } from '../constants'
import { useCurrentBlockTimestamp } from '../hooks/useCurrentBlockTimestamp'
import { useSettings } from '../state/user/hooks'

export const useTransactionDeadline = (chainId: ChainId, enabled = true) => {
  const { data: blockTimestamp } = useCurrentBlockTimestamp(chainId, enabled)
  const [{ userDeadline: ttl, userDeadlineType }] = useSettings()
  return useMemo(() => {
    if (blockTimestamp && ttl) {
      if (userDeadlineType === 'custom') return (blockTimestamp as bigint) + BigInt(ttl)
      return (blockTimestamp as bigint) + BigInt(DEFAULT_DEADLINE_FROM_NOW)
    }
    return undefined
  }, [blockTimestamp, ttl, userDeadlineType])
}
